export default {
      id: "fleche_gauche-usage",
      viewBox: "0 0 70 69",
      url: "../dist/images/" + "sprite.svg#fleche_gauche-usage",
      toString: function () {
        return this.url;
      }
    }